import { render } from "./RotatableArrowDown.vue?vue&type=template&id=23604d2f&scoped=true"
import script from "./RotatableArrowDown.vue?vue&type=script&lang=js"
export * from "./RotatableArrowDown.vue?vue&type=script&lang=js"

import "./RotatableArrowDown.vue?vue&type=style&index=0&id=23604d2f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23604d2f"]])

export default __exports__